import React from "react"
import { Link } from "react-router-dom"
import "../../assets/css/common.css"
import { t } from '../../components/i18n/i18n'
import { usePageLocale } from '../../components/i18n/usePageLocale'
import back from "../../assets/images/elements/aboutHeader.jpg";
import article_img from "../../assets/images/articles/8_full.jpeg"
import articlePdf from "../../resources/9-path-milestones-king.pdf";
import ArticleLike from '../../components/ArticleLike'

export const Article9KingMilestones = () => {
    const ready = usePageLocale('article9');
    if (!ready) return <div style={{ padding: '60px', textAlign: 'center', color: '#999' }}>•••</div>;
    return (

        <section className='text_container_light'>
            <div className='container_100'>
                <div className='backImg15'>
                    <img src={back} alt='' />
                    <div className='text_container_dark_15'>
                        <div className='h1_15'>{t("resourceArticle9Title")}</div>
                    </div>
                </div>

                <br />

                <div className='container boxItems'>
                    <Link to='/resources' style={{textDecoration: 'none', color: '#777'}}>
                        {t("resourceBackToList")}
                    </Link>
                    <br /><br />

                    <div className='article_grid'>
                        {/* ЛІВА КОЛОНКА */}
                        <div>
                            <h2 className='menuColor'>{t("resourceArticle9Title")}</h2>

                            <p>{t("resourceArticle9Author")}</p>
                            <div style={{ marginTop: '10px' }}>
                                <a
                                    href={articlePdf}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="pdf-download-link"
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        color: '#b22222',
                                        textDecoration: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '14px'
                                    }}
                                >
                                    <span style={{ marginRight: '8px' }}>📄</span>
                                    {t("resourceArticleDownloadOriginal")}
                                </a>
                            </div>

                            <hr />
                            <br/>

                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9Epigraph") }} /></p>

                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P4") }} /></p>

                            <h3 className='menuColor'>{t("resourceArticle9Sec1")}</h3>

                            <img
                                src={article_img}
                                alt={t("resourceArticle9Title")}
                                className="article-img"
                            />

                            <br />
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P5") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P6") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P7") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P8") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P9") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P10") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P11") }} /></p>

                            <h3 className='menuColor'>{t("resourceArticle9Sec2")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P12") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P13") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P14") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P15") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P16") }} /></p>

                            <br/>
                            <h3 className='menuColor'>{t("resourceArticle9Sec3")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P17") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P18") }} /></p>
                        </div>

                        {/* ПРАВА КОЛОНКА */}
                        <div>

                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P19") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P20") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P21") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P22") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P23") }} /></p>
                            <br/>

                            <h3 className='menuColor'>{t("resourceArticle9Sec4")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P24") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P25") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P26") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P27") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P28") }} /></p>
                            <br/>

                            <h3 className='menuColor'>{t("resourceArticle9Sec5")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P29") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P30") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P31") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P32") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P33") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P34") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P35") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle9P36") }} /></p>
                            <br/>

                            <hr />
                            <p style={{ fontSize: '13px', color: '#999', marginTop: '10px' }}>
                                {t("resourceArticle9Copyright")}
                            </p>
                            <br/>

                        </div>
                    </div>
                    <ArticleLike articleId='9-havrysiuk-king-milestones' />
                </div>
                <br />
            </div>
        </section>
    )
}
